import client from './client'
import navigator from './navigator'
import toolbar from './toolbar'
import stepAnimations from './stepAnimations'
import stepText from './stepText'
import viewer from './viewer'

let storyboard = {
  firstLaunch: true,
  viewer: null,
  loop: false,
  isLoopDisabled: true,
  collectionOptions: {
    collectionTitle: null,
    currentStory: null
  },
  viewerOptions: {
    id: 'viewer',
    sequenceMode: true,
    tileSources: [],
    prefixUrl: 'images/osd/',
    homeFillsViewer: false,
    showNavigator: true,
    navigatorHeight: undefined,
    navigatorWidth: undefined,
    navigatorId: 'jarvisNavigator',
    navigatorDisplayRegionColor: '#ffe534',
    showNavigationControl: false,
    showSequenceControl: false,
    defaultZoomIn: 1.5,
    defaultZoomOut: 0.5,
    springStiffness: 6.5,
    gestureSettingsMouse: {
      flickEnabled: false,
      clickToZoom: false,
      dblClickToZoom: true
    },
    preserveImageSizeOnResize: true
  },
  DOM: {
    spinnerContainer: null,
    viewerContainer: null,
    toggleChaptersList: null,
    currentStepContainer: null,
    totalStepsContainer: null,
    nextStep: null,
    prevStep: null,
    imageTitle: null,
    imageAuthor: null,
    stepTitle: null,
    stepCaption: null,
    stepContentWidget: null,
    stepTextWrapper: null,
    stepText: null,
    stepContentToggle: null,
    toggleStepContentButton: null,
    stepNumber: null,
    zoomInBtn: null,
    zoomOutBtn: null,
    fullScreenBtn: null,
    exitFullScreenBtn: null,
    stepListContainer: null,
    stepListHeader: null,
    storyTitle: null,
    stepList: null,
    closeStepList: null,
    changeStory: null,
    steps: null,
    navigator: null,
    disableNavigator: false,
    isAnimating: false,
    storyProgress: null,
    toolbar: null
  },
  collectionDOM: {
    collectionListContainer: null,
    collectionTitle: null,
    collectionList: null,
    storyLinks: null
  },
  stepper: {
    currentImage: 0,
    currentAnimationStep: -1,
    totalAnimationSteps: null,
    currentGlobalAnimationStep: 0,
    defaultImageDelay: 10000,
    changePageDelay: 1500,
    directChangePageDelay: 100,
    pageFadeOutDelay: 1000,
    captionFadeDelay: 300,
    directStepAnimationDelay: 200,
    startWithFirstStep: true,
    startWithFirstStepDelay: 0,
    currentRect: null,
    currentZoom: null,
    introLabel: 'Introduzione',
    userStartedLoop: false
  },
  containers: {
    collectionManifests: null,
    annotations: null,
    canvases: null,
    promises: []
  },
  metadata: {
    customerCode: 'haltadefinizione',
    author: null,
    title: null,
    uuid: null
  },

  onAnimationFinish: function () {
    storyboard.DOM.stepContentWidget.classList.remove('collapsed')
    storyboard.viewer.viewport.zoomSpring.springStiffness = storyboard.viewerOptions.springStiffness
    storyboard.viewer.viewport.zoomSpring.animationTime = 1.2
    storyboard.viewer.viewport.zoomSpring.exponential = true
    storyboard.viewer.viewport.centerSpringX.animationTime = 1.2
    storyboard.viewer.viewport.centerSpringX.exponential = false
    storyboard.viewer.viewport.centerSpringY.animationTime = 1.2
    storyboard.viewer.viewport.centerSpringY.exponential = false

    storyboard.DOM.isAnimating = false
    storyboard.activateUI()
    // Mark that the transition is done
    viewer.setTransitionActive(false)
    // Reset the inactivity timer so the countdown restarts
    viewer.resetAutoplayTimer()
  },
  nextStep: function (callback) {
    storyboard.stepper.currentAnimationStep++
    storyboard.stepper.currentGlobalAnimationStep++

    let currentImageStepCount = storyboard.containers.annotations[storyboard.stepper.currentImage].steps.length

    if (storyboard.stepper.currentAnimationStep === currentImageStepCount) {
      storyboard.stepper.currentAnimationStep = 0
      storyboard.stepper.currentImage++

      if (storyboard.stepper.currentImage === storyboard.containers.annotations.length) {
        storyboard.stepper.currentImage = 0
        storyboard.stepper.currentGlobalAnimationStep = 1
      }

      storyboard.changePage()
    } else {
      storyboard.deactivateUI()
      stepAnimations.animate(storyboard, callback)
    }
  },
  prevStep: function () {
    storyboard.stepper.currentAnimationStep--
    storyboard.stepper.currentGlobalAnimationStep--

    if (storyboard.stepper.currentAnimationStep < 0) {
      if (storyboard.stepper.currentImage === 0) {
        storyboard.stepper.currentImage = storyboard.containers.annotations.length - 1
        storyboard.stepper.currentAnimationStep =
          storyboard.containers.annotations[storyboard.stepper.currentImage].steps.length - 1
        storyboard.stepper.currentGlobalAnimationStep = storyboard.stepper.totalAnimationSteps

        storyboard.changePage()
      } else {
        if (storyboard.stepper.currentAnimationStep < 0) {
          storyboard.stepper.currentImage--
          storyboard.stepper.currentAnimationStep =
            storyboard.containers.annotations[storyboard.stepper.currentImage].steps.length - 1

          storyboard.changePage()
        }
      }
    } else {
      storyboard.deactivateUI()

      stepAnimations.animate(storyboard)
    }
  },
  changePage: async function () {
    storyboard.DOM.disableNavigator = true
    navigator.hide(storyboard)
    storyboard.deactivateUI()
    storyboard.DOM.viewerContainer.classList.add('fade-out')

    client
      .getMetaDataForStories(
        `${process.env.API_BASE_URL}meta/images/search/findByUuid?uuid=`,
        storyboard.containers.promises,
        storyboard.stepper.currentImage
      )
      .then(response => {
        storyboard.viewer.viewport.maxZoomPixelRatio = response
        storyboard.viewer.viewport.applyConstraints()
      })

    let to1 = setTimeout(function () {
      clearTimeout(to1)
      stepText.hideStepContent(storyboard)
      storyboard.viewer.goToPage(storyboard.stepper.currentImage)

      let to2 = setTimeout(function () {
        clearTimeout(to2)

        storyboard.DOM.viewerContainer.classList.remove('fade-out')
        stepText.showStepContent(storyboard)

        stepAnimations.animate(storyboard)
      }, storyboard.stepper.changePageDelay)
    }, storyboard.stepper.pageFadeOutDelay)
  },
  deactivateUI: function () {
    stepText.hideStepContent(storyboard, true)
    toolbar.hideButtons(storyboard)
    storyboard.viewer.setMouseNavEnabled(false)
    storyboard.viewer.navigator.element.style.pointerEvents = 'none'
  },
  activateUI: function () {
    storyboard.DOM.toggleChaptersList.classList.remove('disabled')
    storyboard.DOM.prevStep.classList.remove('disabled')
    storyboard.DOM.nextStep.classList.remove('disabled')

    //  One-step story scenario: remove not necessary buttons and show author (if present) instead of title (coincides with first step title)
    if (storyboard.stepper.totalAnimationSteps === 1) {
      storyboard.DOM.toggleChaptersList.closest('.toolbarComponent').style.display = 'none'
      storyboard.DOM.prevStep.closest('.toolbarComponent').style.display = 'none'
      storyboard.DOM.nextStep.closest('.toolbarComponent').style.display = 'none'

      const author = storyboard.containers.annotations[0].author || null
      if (author) storyboard.DOM.imageTitle.innerText = author
    }

    storyboard.viewer.viewport.zoomSpring.animationTime = 1.2
    storyboard.viewer.viewport.centerSpringX.animationTime = 1.2
    storyboard.viewer.viewport.centerSpringY.animationTime = 1.2

    storyboard.viewer.setMouseNavEnabled(true)
    storyboard.viewer.navigator.element.style.pointerEvents = 'initial'

    navigator.show(storyboard)
    toolbar.showButtons(storyboard)
    stepText.showStepContent(storyboard)
  }
}

export default storyboard
